export default __webpack_public_path__ + "static/media/xpIco.01ce3a81.svg";